/**
 * The sign-in screen.
 *
 * There is no form here. Credentials belong to Keycloak, so this hands the browser over
 * and never sees a password.
 */

export function SignInView({ signInHref }: { signInHref: string }) {
  return (
    <div
      className="fade-in"
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 620, width: "100%" }}>
        <h1 className="serif" style={{ fontSize: 30, fontWeight: 400, margin: 0 }}>
          Actuovious
        </h1>
        <p style={{ fontSize: 14, color: "var(--slate)", lineHeight: 1.7, marginTop: 10 }}>
          What your vendors report about themselves, set against what your own records say.
          Sign in to continue.
        </p>

        <a
          href={signInHref}
          style={{
            display: "inline-block",
            marginTop: 18,
            background: "var(--gold)",
            color: "var(--ink)",
            borderRadius: 8,
            padding: "11px 22px",
            fontSize: 13.5,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Sign in
        </a>
      </div>
    </div>
  );
}
